import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconNotifications({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M9.28.5a1 1 0 0 1 .948.684L12 6.5v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4l1.772-5.316A1 1 0 0 1 2.721.5h6.558zM1 7.5v3h10v-3H8.83a3.001 3.001 0 0 1-5.66 0H1zm9.946-1H8a2 2 0 1 1-4 0H1.054l1.667-5h6.558l1.667 5z"/>
        </svg>
    );
}

export default IconNotifications;

